import { alpha, type ThemeOptions } from "@mui/material";

export const CUSTOM_COMPONENTS: ThemeOptions["components"] = {
  MuiOutlinedInput: {
    styleOverrides: {
      notchedOutline: ({ theme }) => ({
        borderColor: alpha(`${theme.palette.secondary[200]}`, 0.75),
      }),
    },
    variants: [
      {
        props: {},
        style: ({ theme }) => ({
          "&:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.secondary[200],
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.primary.main,
          },
        }),
      },
    ],
  },
  MuiTypography: {
    variants: [
      {
        props: {},
        style: ({ theme }) => ({
          color: theme.palette.text.primary,
          textTransform: "none",
        }),
      },
    ],
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        backgroundColor: alpha(`${theme.palette.secondary.main}`, 0.9),
      }),
      arrow: ({ theme }) => ({
        color: alpha(`${theme.palette.secondary.main}`, 0.9),
      }),
    },
  },
  MuiButton: {
    variants: [
      {
        props: {},
        style: {
          textTransform: "none",
        },
      },
    ],
  },
  MuiDivider: {
    variants: [
      {
        props: {},
        style: ({ theme }) => ({
          borderColor: theme.palette.secondary.light,
        }),
      },
    ],
  },
  MuiStepper: {
    styleOverrides: {
      root: ({ theme }) => ({
        ".MuiSvgIcon-root.Mui-active": {
          color: theme.palette.primary.dark,
        },
        ".MuiStepIcon-text": {
          fontWeight: theme.typography.fontWeightMedium,
        },
      }),
    },
  },
};
